import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { ActionBackOfficeResponse } from '../../../models/api.model';
import {
  EvSpaceChargerStatusDto,
  EvStationManualEntryPayload,
  EvStationSpaceCardDto,
} from '../../../models/cityparking/ev-station-monitor.model';

@Injectable({ providedIn: 'root' })
export class ApiEvStationMonitorService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  getEvStationSpaceCards(siteId?: number): Observable<EvStationSpaceCardDto[]> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = {};
    if (siteId && siteId > 0) {
      params['siteId'] = siteId;
    }

    return this.apiMethodService.request<EvStationSpaceCardDto[]>(
      '/SystemSettings/getEvStationSpaceCards',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getEvStationSpaceCards',
        token,
        headerOnly: false,
        params,
      }
    );
  }

  getEvSpaceChargerStatus(siteId: number): Observable<EvSpaceChargerStatusDto> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<EvSpaceChargerStatusDto>(
      '/SystemSettings/getEvSpaceChargerStatus',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getEvSpaceChargerStatus',
        token,
        headerOnly: false,
        params: { siteId },
      }
    );
  }

  createEvStationManualEntry(
    payload: EvStationManualEntryPayload,
  ): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/SystemSettings/createEvStationManualEntry',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'createEvStationManualEntry',
        token,
        headerOnly: false,
        body: payload,
      }
    );
  }
}
